import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { Button, Grid, Typography } from '@mui/material';
import { RootState, useAppDispatch, useAppSelector } from '../../store/store';
import { GetTestingDatasetDetails, handleToggleFileDetailsPopup } from '../../store/mltester-slice/mltester';
import { useTranslation } from 'react-i18next';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { useEffect, useMemo } from 'react';
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import Transition from '../common/Transition';
import { Header } from '../common/Header';
import TableRowsIcon from '@mui/icons-material/TableRows';
import ViewWeekIcon from '@mui/icons-material/ViewWeek';

const TesterFileDetails = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const { fileDetailsPopupOpen, fileDetailsBodyParams, fileDetailsLoading, fileDetails } = useAppSelector((state: RootState) => state.mltester);
  
    const columns: GridColDef[] = useMemo(() => [
        { field: 'id', headerName: t('FILE_DETAILS_ID_FIELD'), width: 90 },
        { field: 'name',  headerName: t('FILE_DETAILS_COLUMN_NAME_FIELD'), flex: 1 },
        { field: 'type', headerName: t('FILE_DETAILS_COLUMN_TYPE_FIELD'), flex: 0.5, renderCell: (params) => { return t(`${params.value}`)} },
    ], [])

    function handleClose() {
        dispatch(handleToggleFileDetailsPopup({ open: false, body: null }));
    }
    
    useEffect(() => {
        if(fileDetailsBodyParams) {
            dispatch(GetTestingDatasetDetails(fileDetailsBodyParams.fileId));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fileDetailsBodyParams])

    if(!fileDetailsBodyParams) return <></>;

    return(
        <Dialog
            fullWidth
            maxWidth="md"
            open={fileDetailsPopupOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={(_, reason) => {
                if(reason !== 'backdropClick') handleClose();
            }}
            aria-describedby="alert-dialog-slide-description"
        >
        <Header 
            title={t('FILE_DETAILS_TITLE', { fileName: fileDetailsBodyParams.fileName })} 
        />
        <DialogContent>
                { !fileDetails || fileDetailsLoading ? 
                <Grid container p={2} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    { fileDetailsLoading ? 
                        <Box sx={{ width: '100%' }}>
                            <LinearProgress />
                        </Box>
                    : !fileDetails ? 
                        <Typography variant={'h6'}>{t('NO_FILE_DETAILS')}</Typography>
                    : '' }
                </Grid> : 
                <Grid container sx={{ display: 'flex', flexDirection: 'column'}} spacing={1}>
                    <Grid ml={0.5} item style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <TableRowsIcon style={{ fontSize: '18px', color: 'darkgray' }}/>
                        <Typography ml={1} variant='body1' style={{fontWeight: 'bold'}}>{t('FILE_DETAILS_ROW_COUNT', { rowCount: fileDetails.rowCount })}</Typography>
                    </Grid>
                    <Grid ml={0.5} item style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <ViewWeekIcon style={{ fontSize: '18px', color: 'darkgray' }}/>
                        <Typography ml={1} variant='body1' style={{fontWeight: 'bold'}}>{t('FILE_DETAILS_COLUMN_COUNT', { columnCount: fileDetails.columnCount })}</Typography>
                    </Grid>
                    <Grid item>
                        <Box sx={{ height: 350, width: '100%' }}>
                            <DataGrid
                                rows={fileDetails.columns}
                                columns={columns}
                                initialState={{
                                    pagination: {
                                        paginationModel: {
                                            pageSize: 10,
                                        },
                                    },
                                }}
                                pageSizeOptions={[5, 10, 25]}
                                rowHeight={30}
                                columnHeaderHeight={35}
                            />
                        </Box>
                    </Grid>
                </Grid>
                }
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>{t('CLOSE_BUTTON')}</Button>
            </DialogActions> 
        </Dialog>
    )
}

export default TesterFileDetails;